const languages = [
  { label: 'NO', value: 'no_NO', id: 1 },
]

export default languages
